<template>
  <div
    class="pointer mb-32"
    role="button"
    @click="handleClick"
  >
    <i class="bi bi-arrow-left" />
    {{ label }}
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'

defineProps({
  label: {
    required: true,
    type: String,
    default: 'Kembali'
  }
})

const emit = defineEmits(['click'])
const handleClick = () => {
  emit('click')
}
</script>
